import PropTypes from 'prop-types';
import addressShape from 'react/signups/card/shapes/AddressShape';

const cardholderProfileShape = PropTypes.shape({
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  sameAddress: PropTypes.string,
  address: addressShape,
  dateOfBirth: PropTypes.string,
  mobile: PropTypes.string,
  skip: PropTypes.bool,
});

export default cardholderProfileShape;
